// extracted by mini-css-extract-plugin
export default {"Section":"Books_Section__fjJW4","Loading":"Books_Loading__lHJ6J"};